"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.627 10.374a2.3 2.3 0 1 0 0 3.253m0-3.253a2.3 2.3 0 0 1 0 3.253zm.99-.99a3.7 3.7 0 1 0-5.234 5.232 3.7 3.7 0 0 0 5.234-5.232",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 6.2c-3.158 0-5.988 1.715-7.26 4.33-.225.464-.34.965-.34 1.47 0 .504.115 1.005.34 1.47C6.013 16.084 8.843 17.8 12 17.8s5.988-1.715 7.26-4.33A3.36 3.36 0 0 0 19.6 12a3.36 3.36 0 0 0-.34-1.47C17.987 7.915 15.157 6.2 12 6.2M3.482 9.918C5.005 6.782 8.35 4.8 12 4.8s6.995 1.982 8.518 5.118A4.76 4.76 0 0 1 21 12c0 .72-.165 1.429-.482 2.081C18.995 17.217 15.65 19.2 12 19.2s-6.995-1.983-8.518-5.119A4.76 4.76 0 0 1 3 12c0-.72.165-1.43.482-2.082",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EyeShowIcon24.js.map